import { useGetSnk } from "@/components/parts/admin/snk/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { FormField } from "@/components/ui/form";
import { FileText } from "lucide-react";
import React from "react";
import { FieldValues, Path, useFormContext } from "react-hook-form";

interface CustomFormSnkProps<T extends FieldValues = FieldValues> {
  name: Path<T>;
}

export default function CustomFormSnk<T extends FieldValues = FieldValues>({
  name,
}: CustomFormSnkProps<T>) {
  const form = useFormContext<T>();

  const { data: _snk } = useGetSnk();
  const snk = _snk?.data;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <div className="flex items-center gap-4">
          <Checkbox
            className="border-white"
            checked={field.value}
            onCheckedChange={field.onChange}
          />
          <div className="text-sm text-white">
            Ya, saya telah membaca, memahami, dan menyetujui{" "}
            <Dialog>
              <DialogTrigger type="button" className="underline">
                Syarat & Ketentuan
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle className="flex gap-2 items-center">
                    <FileText className="rotate-180" />
                    Syarat dan Ketentuan
                  </DialogTitle>
                </DialogHeader>
                <DialogDescription
                  dangerouslySetInnerHTML={{
                    __html: snk?.termCondition ?? "-",
                  }}
                />
                <DialogClose>
                  <Button
                    onClick={() => {
                      field.onChange(true);
                    }}
                  >
                    Saya Setuju
                  </Button>
                </DialogClose>
              </DialogContent>
            </Dialog>{" "}
            dan{" "}
            <Dialog>
              <DialogTrigger type="button" className="underline">
                Kebijakan dan Privasi
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle className="flex gap-2 items-center">
                    <FileText className="rotate-180" />
                    Kebijakan dan Privasi
                  </DialogTitle>
                </DialogHeader>
                <DialogDescription
                  dangerouslySetInnerHTML={{
                    __html: snk?.privacyPolicy ?? "-",
                  }}
                />
                <DialogClose>
                  <div
                    onClick={() => {
                      field.onChange(true);
                    }}
                  >
                    Saya Setuju
                  </div>
                </DialogClose>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      )}
    />
  );
}
